<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <div class="goal-detail">
                <h5 class="card-title" v-tooltip:top="portfolio.portfolio_type.description">{{ portfolio.portfolio_type.name }}</h5>
            </div>
            <div class="goal-detail">
                <h6 class="card-subtitle mb-2 text-muted">Portfolio ID</h6>
                <h5 class="card-title">{{ portfolio.external_portfolio_id }}</h5>
            </div>
            <div class="goal-detail">
                <h6 class="card-subtitle mb-2 text-muted">Portfolio value</h6>
                <h5 class="card-title">{{  portfolio.value|toCurrency(portfolio.currency) }}</h5>
            </div>
            <button v-if="portfolio.portfolio_type.status !== 1" class="btn btn-outline-default btn-block shadow-sm" disabled>
                {{ (user === 'back-office') ? "Not Available" : "Coming Soon" }}
            </button>
            <router-link v-else class="btn btn-outline-default btn-block shadow-sm" v-tooltip:bottom="'Portfolio details, deposits and withdrawals'" :to="{ name: (user === 'back-office') ? 'portfolios.show' : 'portfolio.details', params: { portfolio: portfolio.external_portfolio_id } }">
                {{ (user === 'back-office') ? "Manage" : "Details" }}
            </router-link>
        </div>
    </div>
</template>

<style scoped>
	.card {
		height: 280px;
	}

	.card-body {
		padding: 25px;
	}

	.goal-detail {
		margin-bottom: 25px;
	}
</style>

<script>
	export default {
		data() {
			return {
				user: this.$store.getters.user.type
			};
		},
		props: ["portfolio"]
	};
</script>